import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/industries/diesel-generators/page.tsx");
